// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AdditionalServices_GetResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /so/additional_services/get/{id}.
 *
 * Returns a single additional service record. The shape mirrors the SELECT in
 * So_additional_services_model::getById() — `SELECT a.*, c.so_service_category_name`
 * — i.e. every column of `so_additional_services` plus the joined category name.
 *
 * Unlike /lista, this endpoint does NOT divide the price by 100 and does NOT
 * alias `category_name`; the only controller-side mutation is converting
 * `so_additional_service_created_at` from MySQL GMT-3 to ISO 8601 UTC.
 * The price is therefore the raw integer (cents) straight from the column.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AdditionalServices_GetResponseDados {
so_additional_service_id?: number
so_additional_service_category_id?: number
so_additional_service_name?: string
so_additional_service_description?: string
so_additional_service_default_price?: number
so_additional_service_additional_deadline_days?: number
so_additional_service_active?: number
so_additional_service_created_at?: string
so_service_category_name?: string
}

export type AdditionalServices_GetResponse = ApiResponse<AdditionalServices_GetResponseDados>;

registerResponseContract('AdditionalServices_GetResponse', {
  so_additional_service_id:                       { type: 'number',  required: false },
  so_additional_service_category_id:              { type: 'number',  required: false },
  so_additional_service_name:                     { type: 'string',  required: false },
  so_additional_service_description:              { type: 'string',  required: false },
  so_additional_service_default_price:            { type: 'number',  required: false },
  so_additional_service_additional_deadline_days: { type: 'number',  required: false },
  so_additional_service_active:                   { type: 'number',  required: false },
  so_additional_service_created_at:               { type: 'string',  required: false },
  so_service_category_name:                       { type: 'string',  required: false },
})
